
export const actionTypes = {
  SET_PETS_REASON_SELECTION: "SET_PETS_REASON_SELECTION",
  SET_CURRENT_PET_INDEX: "SET_CURRENT_PET_INDEX",
  RESET_REASONS_NAVIGATION_STORE: "RESET_REASONS_NAVIGATION_STORE",
};

const setPetsReasonSelection = (payload: any) => ({
  type: actionTypes.SET_PETS_REASON_SELECTION,
  payload,
});
const setCurrentNavigationIndex = (payload: any) => ({
  type: actionTypes.SET_CURRENT_PET_INDEX,
  payload,
});

const resetReasonsNavigationStore = () => ({
  type: actionTypes.RESET_REASONS_NAVIGATION_STORE,
});

export default {
  setPetsReasonSelection,
  setCurrentNavigationIndex,
  resetReasonsNavigationStore,
};
